module.exports = __webpack_public_path__ + "media/entities/1608-959f9802.png";